import { schema } from 'normalizr';

const CUSTOMIZED_THEME_SCHEMA = new schema.Entity('customizedTheme', {}, { idAttribute: '@id' });

export default {
  CustomizedTheme: CUSTOMIZED_THEME_SCHEMA,
};
